import { render } from "./RiCountry.vue?vue&type=template&id=3a47834e"
import script from "./RiCountry.vue?vue&type=script&lang=js"
export * from "./RiCountry.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiCountry.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3a47834e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3a47834e', __exports__)) {
    api.reload('3a47834e', __exports__)
  }
  
  module.hot.accept("./RiCountry.vue?vue&type=template&id=3a47834e", () => {
    api.rerender('3a47834e', render)
  })

}


export default __exports__